<template lang="pug">
.app-card.overflow-x-auto.contacts-styled-panel
  //- Header con título e ícono
  .d-flex.align-items-center.justify-content-between.tw-mb-3.tw-pb-2.tw-border-b.tw-border-gray-200
    .d-flex.align-items-center.tw-gap-2
      i.fa-solid.fa-address-book.tw-text-purple-600
      span.tw-font-semibold.tw-text-gray-700 {{ $I18n.t('vue.contacts_detail_panel.panel_title') }}
      span.tw-bg-purple-100.tw-text-purple-700.tw-px-2.tw-py-1.tw-rounded-full.tw-text-xs.tw-font-medium {{ items.length }}
    edit-contact-modal(
      :data-icon='"fa-solid fa-plus"'
      :data-label="$I18n.t('vue.contacts_detail_panel.title')"
      :data-title="$I18n.t('vue.contacts_detail_panel.new_contact')"
      :data-mode='"new"'
      :data-item='JSON.stringify(empty_item)'
      :data-id='record.id' 
      :data-model='record.model'
      :data-send-invoice-option='send_invoice_option'
      @updated='createNewContact'
    )

  //- Tabla de contactos
  .table-responsive(v-if='!emptyItems')
    table.table.table-hover.contacts-styled-table
      thead
        tr
          th.tw-text-center(style="width: 40px;") #
          th(style="width: 100px;") Role
          th(style="width: 180px;") Name
          th(style="width: 200px;") Email
          th.tw-text-center(style="width: 180px;") Phones
          th.tw-text-center(style="width: 100px;") Actions
      tbody
        tr(v-for="(item, index) in items" :key="item.id" :class="getContactRowClass(item)")
          //- Número
          td.tw-text-center.tw-text-gray-400 {{ index + 1 }}
          //- Role
          td
            span.tw-text-sm(v-if="item.role_name") {{ item.role_name }}
            span.tw-text-gray-400.tw-text-xs.tw-italic(v-else) -
          //- Name
          td
            .d-flex.align-items-center
              .tw-w-8.tw-h-8.tw-rounded-full.tw-bg-purple-100.d-flex.align-items-center.justify-content-center.tw-mr-2
                i.fa-solid.fa-user.tw-text-purple-600.tw-text-xs
              span.tw-font-medium {{ getFullName(item) }}
          //- Email
          td
            div(v-if="item.email")
              a.tw-text-blue-600.tw-text-sm(:href="'mailto:'+item.email")
                i.fa-solid.fa-envelope.tw-mr-1.tw-text-xs
                | {{ item.email }}
              span.tw-ml-2.tw-px-2.tw-py-1.tw-rounded-full.tw-text-xs.tw-bg-green-100.tw-text-green-700(v-if="item.send_invoice")
                i.fa-solid.fa-check.tw-mr-1
                | Invoice
            span.tw-text-gray-400.tw-text-xs(v-else) -
          //- Phones
          td
            .d-flex.flex-column.tw-gap-1.phone-section
              .d-flex.align-items-center.tw-gap-1.tw-justify-between(v-for="phone in getPhones(item)" :key="phone.id")
                .d-flex.align-items-center.tw-gap-1
                  span.tw-px-1.tw-py-0.tw-rounded.tw-text-xs.tw-bg-blue-100.tw-text-blue-700(v-if="phone.kind") {{ phone.kind }}
                  span.tw-text-sm.tw-font-mono {{ phone.number }}
                .d-flex.tw-gap-1.phone-mini-actions
                  edit-phone-contact-modal(
                    :data-id='String(phone.id)'
                    :data-contact-id='String(item.id)'
                    :data-model='"Contact"'
                    :data-item='JSON.stringify(phone)'
                    :data-icon='"fa-solid fa-pen-to-square"'
                    :data-label='""'
                    :data-mode='"update"'
                    :data-title="$I18n.t('vue.contacts_detail_panel.edit_phone_contact')"
                    @updated='updatePhoneContact'
                  )
                  delete-phone-contact-modal(
                    :data-id='phone.id'
                    @deleted='retrieveContacts'
                  )
              span.tw-text-gray-400.tw-text-xs.tw-italic(v-if="!item.phones || item.phones.length === 0") No phones
              .phone-add-btn
                edit-phone-contact-modal(
                  :data-id='""'
                  :data-contact-id='String(item.id)'
                  :data-model='"Contact"'
                  :data-item='JSON.stringify(empty_phone_item)'
                  :data-icon='"fa-solid fa-circle-plus"'
                  :data-label='"Add"'
                  :data-title="$I18n.t('vue.contacts_detail_panel.new_phone_contact')"
                  :data-mode='"new"'
                  @updated='createNewPhoneContact'
                )
          //- Actions
          td.tw-text-center
            .d-flex.justify-content-center.tw-gap-2.contact-actions
              //- Edit Contact Button - Blue styled
              edit-contact-modal(
                :data-icon='"fa-solid fa-user-pen"'
                :data-label='"Edit"'
                :data-title="$I18n.t('vue.contacts_detail_panel.edit_contact')"
                :data-mode='"edit"'
                :data-item='JSON.stringify(item)'
                :data-send-invoice-option='send_invoice_option'
                @updated='updateContact'
              )
              //- Delete Contact Button - Red styled  
              delete-contact-modal(
                :data-id='item.id'
                @deleted='retrieveContacts'
              )

  //- Estado vacío
  .tw-text-center.tw-py-8(v-if='emptyItems')
    .tw-w-16.tw-h-16.tw-bg-purple-100.tw-rounded-full.d-flex.align-items-center.justify-content-center.tw-mx-auto.tw-mb-3
      i.fa-solid.fa-address-book.tw-text-purple-400.tw-text-2xl
    p.tw-text-gray-500.tw-mb-0 {{ $I18n.t('vue.contacts_detail_panel.empty_items') }}
</template>
<script>

import DeleteContactModal from './delete-contact-modal.vue'
import EditContactModal from './edit-contact-modal.vue'
import {BackendService} from '../../services';
import EditPhoneContactModal from './edit-phone-contact-modal.vue';
import DeletePhoneContactModal from './delete-phone-contact-modal.vue';

export default {
  components:{
    'delete-contact-modal':DeleteContactModal,
    'edit-contact-modal':EditContactModal,
    'edit-phone-contact-modal': EditPhoneContactModal,
    'delete-phone-contact-modal': DeletePhoneContactModal,
  },
  props:{
    dataId: String,
    dataModel: String,
    dataItems: String,
    dataSendInvoiceOptions: String,
  },
  data: function(){
    return {
      state: {
        confirmed: false,
      },
      record:{
        id: this.dataId,
        model: this.dataModel
      },
      send_invoice_option: this.dataSendInvoiceOptions,
      items: JSON.parse(this.dataItems),
      empty_item: {
        person:{},
        phones:[
          {kind:"",number:""}
        ]
      },
      empty_phone_item: {
        kind:"",
        number:""
      },
    }
  },
  computed:{
    emptyItems: function(){
      return this.items.length === 0;
    }
  },
  methods:{
    getFullName: function(item) {
      if (!item || !item.person) return 'No name';
      const parts = [
        item.person.first_name,
        item.person.middle_name,
        item.person.last_name
      ].filter(p => p && p.trim());
      return parts.length > 0 ? parts.join(' ') : 'No name';
    },
    getPhones: function(item) {
      return item && item.phones ? item.phones : [];
    },
    getContactRowClass: function(item) {
      if (item && item.send_invoice) return "tw-bg-green-50 tw-bg-opacity-30";
      return "";
    },
    retrieveContacts:function(){
      let self = this; 
      BackendService
        .contacts(JSON.stringify({
          query:{
            contactable_type: self.record.model,
            contactable_id: self.record.id
          }
        }))
        .then((response)=>{
          self.result = response;
          if (response.isOk){
            self.items = response.contacts;
          }
        })
        .finally(()=>{
        })
    },
    updateContact:function(params){
      const self = this;
      this.state.sending = true;
      BackendService
        .contact_update(params)
        .then((response) => {
          if (response.isOk) {
            location.reload();
          }
        })
        .catch(() => {
          self.result.isError = true;
          self.result.notice = "error_promise";
          self.state.sending = false;
        });
    },
    createNewContact:function(params){
      const self = this;
      this.state.sending = true;
      BackendService
        .create_contact(params)
        .then((response)=>{
          self.result = response;
          if (response.isOk){
            location.reload();
          }
        })
        .catch(()=>{
          self.result.isError=true;
          self.result.notice='error_promise';
          self.state.sending = false;
        })
        .finally(()=>{
        })
    },
    createNewPhoneContact:function(params){
      const self = this;
      this.state.sending = true;
      BackendService
        .create_phone_contact(params)
        .then((response)=>{
          self.result = response;
          if (response.isOk){
            location.reload();
          }
        })
        .catch(()=>{
          self.result.isError=true;
          self.result.notice='error_promise';
          self.state.sending = false;
        })
        .finally(()=>{
        })
    },
    updatePhoneContact:function(params){
      const self = this;
      this.state.sending = true;
      BackendService
        .contact_phone_update(params)
        .then((response) => {
          if (response.isOk) {
            location.reload();
          }
        })
        .catch(() => {
          self.result.isError = true;
          self.result.notice = "error_promise";
          self.state.sending = false;
        });
    },
  }
}
</script>

<style scoped>
.contacts-styled-panel {
  padding: 1rem;
  background: white;
  border-radius: 0.375rem;
}

.contacts-styled-table {
  font-size: 0.85rem;
  margin-bottom: 0;
}

.contacts-styled-table thead th {
  white-space: nowrap;
  vertical-align: middle;
  padding: 0.5rem 0.75rem;
  background-color: #f8f9fa;
  border-bottom: 2px solid #dee2e6;
  font-weight: 600;
  color: #495057;
}

.contacts-styled-table tbody td {
  vertical-align: middle;
  padding: 0.5rem 0.6rem;
}

.contacts-styled-table tbody tr:hover {
  background-color: rgba(139, 92, 246, 0.05);
}

/* Phone Section - Smaller/subtle buttons */
.phone-section {
  font-size: 0.85rem;
}

.phone-mini-actions {
  opacity: 0.6;
  transition: opacity 0.2s ease;
}

.phone-mini-actions:hover {
  opacity: 1;
}

.phone-mini-actions >>> .app-btn-link {
  font-size: 0.75rem !important;
  color: #6b7280 !important;
  padding: 0.15rem 0.25rem !important;
}

.phone-mini-actions >>> .app-btn-link:hover {
  color: #374151 !important;
}

.phone-add-btn {
  margin-top: 0.25rem;
}

.phone-add-btn >>> .app-btn-link {
  font-size: 0.75rem !important;
  color: #059669 !important;
}

/* Contact Actions Styling - Prominent buttons */
.contact-actions {
  display: flex;
  gap: 0.5rem;
  justify-content: center;
}

.contact-action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.35rem 0.6rem;
  border-radius: 0.375rem;
  transition: all 0.2s ease;
  font-size: 0.8rem;
}

.contact-action-edit {
  background-color: #dbeafe;
  border: 1px solid #93c5fd;
}

.contact-action-edit:hover {
  background-color: #bfdbfe;
  border-color: #60a5fa;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(59, 130, 246, 0.2);
}

.contact-action-edit >>> .app-btn-link {
  color: #1d4ed8 !important;
  font-weight: 500;
}

.contact-action-delete {
  background-color: #fee2e2;
  border: 1px solid #fca5a5;
}

.contact-action-delete:hover {
  background-color: #fecaca;
  border-color: #f87171;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(220, 38, 38, 0.2);
}

.contact-action-delete >>> .app-btn-link {
  color: #dc2626 !important;
  font-weight: 500;
}

/* Avatar circular */
.tw-w-8 {
  width: 2rem;
}
.tw-h-8 {
  height: 2rem;
}
</style>
